<template>
  <keep-alive>
    <div class="container flex flex-col mx-auto">
      <Home></Home>
    </div>
  </keep-alive>
</template>

<script lang="ts" setup>
import { useClassInfoArray } from '~/stores/livingClass/classInfoArray'
import { useWorkInfoArray } from '~/stores/workList/workListInfoArray'
import { useLoginInfo } from '~/stores/user/loginInfo'
const classStore = useClassInfoArray()
const workListStore = useWorkInfoArray()
const loginInfo = useLoginInfo()

//请求获取课程列表
async function getClassArray() {
  const obj = {
    url: RequestAPI.GET_CLASS_ARRAY,
    body: {
      page: 1,
      size: 8,
      platform: loginInfo.platform,
    },
  }
  const { data, status } = await postRequired(obj)
  if (data.value) {
    if (data.value.code === 2000) {
      classStore.updateClassInfoArray(data.value.data.list)
    }
  }
  // console.log("data.value === ", data.value)
}

//请求获取作品列表
async function getWorkList() {
  const obj = {
    url: RequestAPI.GET_WORK_LIST,
    body: {
      page: 1,
      size: 8,
    },
  }
  const { data } = await postRequired(obj)
  console.log('workList is === ', data.value.data.workList)
  if (data.value) {
    workListStore.updateWorkInfoArray(data.value.data.data)
    console.log('请求成功 === ', workListStore.getWorkInfoArray)
  }
}

useHead({
  title: '智惠教室学习中心',
})
</script>

<style scoped></style>
